import { getComponentUiText } from "@/utils/utilities";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { successStatusCodes } from "@/utils/constants";
import store from "@/store";

const objStatus = {
  MFA_REGISTERED: {
    name: getComponentUiText("app-settings-team-members-status-mfa-totp-1"),
    className: "totp",
  },
  MFA_NOT_REGISTERED: {
    name: getComponentUiText("app-component-table-cell-status-pending-1"),
    className: "pending",
  },
  MFA_NOT_REQUIRED: {
    name: getComponentUiText("app-settings-team-members-status-mfa-not-req-1"),
    className: "not__req",
  },
  MFA_REGISTERED_PK: {
    name: getComponentUiText("app-settings-team-members-status-mfa-totp-1"),
    name2: getComponentUiText("app-settings-team-members-status-mfa-passkey-1"),
    className: "totp__passkey",
  },
  MFA_REGISTERED_PKONLY: {
    name: getComponentUiText("app-settings-team-members-status-mfa-passkey-1"),
    className: "passkey",
  },
};

const success = (message) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.SUCCESS,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};
const showError = (message) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.ERROR,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

export const getStatusMfa = (data: any) => {
  return objStatus[data.value];
};

export const _resetAuthenApp = async () => {
  try {
    const res = await store.dispatch("User/resetMfaAuthenApp");
    if (!(res.status === successStatusCodes.OK)) {
      showError(
        res?.data?.error?.message ||
          getComponentUiText("app-exception-handler-error-unknown-error"),
      );
    } else {
      success(
        getComponentUiText(
          "app-settings-team-members-toast-member-remove-mfa-successfully-1",
        ),
      );
      return { success: true };
    }
  } catch (error: any) {
    showError(error?.data?.error?.message);
  }
};
